export default __webpack_public_path__ + "static/media/g2022-25.a1134fe9.jpeg";